import { coreApi } from './api';

export default async function fetchYearsData(accessToken) {
	const res = await coreApi.get('/anio', {
		headers: {
			Authorization: `Bearer ${accessToken}`,
			accept: '*/*',
		},
	});

	return res?.data;
}
